<div class="booking-card" [routerLink]="['/account/bookings/',booking.bookingID]" title="View your booking details">
    <div class="flex">
        @if (booking.event.image) {
            <div class="min-w-16 min-h-16 max-h-16 max-w-16 bg-center bg-cover rounded-xl shadow-md shadow-lrpTicketBlack" [title]="booking.event.eventHost.name" style="background-image: url('{{ booking.event.image.url}}');">
                @if (booking.event.eventHost.img) {
                    <img [src]="booking.event.eventHost.img.url" class="w-6 my-1 mx-1 mix-blend-multiply hover:w-10 hover:mt-3 hover:ms-2" [alt]="booking.event.eventHost.name" [title]="booking.event.eventHost.name">
                }
            </div>
        }
        @else {
            <div class="min-w-16 min-h-16 max-h-16 max-w-16 p-2 rounded-xl shadow-md shadow-lrpTicketBlack">
                @if (booking.event.eventHost.img) {
                    <img [src]="booking.event.eventHost.img.url" class="mix-blend-multiply" [alt]="booking.event.eventHost.name" [title]="booking.event.eventHost.name">
                }
            </div>
        }
        <div class=" ms-4">
            @if (includeLink){
                <p class="text-xs font-semibold cursor-pointer hover:scale-110" [title]="'View ' + booking.event.name" [routerLink]="'/events/' + booking.event.eventLink">{{ booking.event.name }}</p>
            }
            @else {
                <p class="text-xs font-semibold cursor-pointer" >{{ booking.event.name }}</p>
            }
            <p class="text-xs text-gray-400">{{booking.event.eventHost.eventSystem.name }} {{ booking.event.eventHost.display ? ' - ' + booking.event.eventHost.name + ' ' : '' }}</p>
            <p class="text-xs text-gray-400">                    
                @if (booking.event.eventStart == booking.event.eventEnd) {
                    {{ booking.event.eventStart | date:'shortDate' : 'en-GB'}}
                }
                @else if (booking.event.eventStart != booking.event.eventEnd) {
                    {{ booking.event.eventStart | date:'shortDate' : 'en-GB'}} - {{ booking.event.eventEnd | date:'shortDate' : 'en-GB'}}
                }
            </p>
            @if (hasPlayerTicket){
                <fa-icon [icon]="['fas','ticket']" class="text-gray-400" title="Player Ticket" />
            }
            @if (hasCrewTicket){
                <fa-icon [icon]="['fas','spaghetti-monster-flying']" class="text-gray-400" title="Crew Ticket" />
            }
            @if (hasStaffTicket){
                <fa-icon [icon]="['fas','stopwatch']" class="text-gray-400" title="Staff Ticket" />
            }
            @if (hasMealTicket){
                <fa-icon [icon]="['fas','utensils']" class="text-gray-400" title="Meal Ticket" />
            }
            @if (hasOptionalTicket){

            }
            @if (booking.paid){
                <fa-icon [icon]="['fas','circle-check']" class="text-green-400" title="Booking Paid!" />
            }
            @else if (booking.payOnGate) {
                <fa-icon [icon]="['fas','right-to-bracket']" class="text-amber-400" title="Pay on the gate" />
            }
            @else {
                <fa-icon [icon]="['fas','credit-card']" class="text-lrpTicketRed" title="Pay on the gate" />
            }
        </div>
    </div>
</div>